import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const CertificadosDefault = Default;

export default CertificadosDefault;
export const CertificadosAdicionar = Adicionar;
export const CertificadosEditar = Editar;
